import type { GroupLabel } from "@/lib/grouping"

type Phase = { id: string; name: string; position: number }

const NO_PHASE: GroupLabel = {
  key: "",
  label: "No phase",
  order: Number.MAX_SAFE_INTEGER,
}

function labelOf(phase: Phase): GroupLabel {
  return { key: phase.id, label: phase.name, order: phase.position }
}

export function phaseGroupsOf(
  phases: Phase[],
  phaseIds: string[],
): GroupLabel[] {
  const joined = phases.filter((phase) => phaseIds.includes(phase.id))
  return joined.length > 0 ? joined.map(labelOf) : [NO_PHASE]
}

export function phaseGroups(phases: Phase[]): GroupLabel[] {
  return phases.map(labelOf)
}

export function rephased(
  phaseIds: string[],
  shared: string[],
  chosen: string[],
): string[] {
  const kept = phaseIds.filter(
    (phaseId) => chosen.includes(phaseId) || !shared.includes(phaseId),
  )
  return [...kept, ...chosen.filter((phaseId) => !kept.includes(phaseId))]
}

export function movedPhase(
  phases: Phase[],
  phaseId: string,
  offset: -1 | 1,
): string[] {
  const ids = phases.map((phase) => phase.id)
  const from = ids.indexOf(phaseId)
  const to = from + offset
  if (from < 0 || to < 0 || to >= ids.length) return ids
  const reordered = [...ids]
  reordered.splice(from, 1)
  reordered.splice(to, 0, phaseId)
  return reordered
}
